export enum ServerType
{
	ManualRaise = 435
}
